// ---------------------------------------------------------------------------
// Identidade da empresa — usada nos DOCUMENTOS IMPRESSOS (comprovante de
// movimento de estoque, handoff de design "Comprovantes de impressão dos
// movimentos", 2026-09-13).
//
// Por que é constante e não vem da API: o sistema é **single-company** por
// construção — o doc de current-state do backend registra que o CNPJ é uma
// string hardcoded dentro do template de PDF do `MovementController`
// (handoff 0090 §8). Trazer isso para o front não introduz um hardcode novo:
// move o que já existia para um lugar nomeado, versionado e visível.
//
// ⚠️ **PENDENTE DE CONTRATO — endereço da filial.** O documento pede o
// endereço do PDV no cabeçalho, e o front não tem esse dado: `GET
// /users/me/pdvs` devolve apenas `{ id, pdv_name }`. Enquanto o backend não
// expuser a identidade do PDV, `branchAddress` fica null e o cabeçalho omite a
// linha (nunca imprime placeholder). Spec aberta em
// `docs/handoffs/2026-09-13-movement-receipt-backend-spec.md`.
//
// ⚠️ **CONFERIR OS VALORES.** Vieram do protótipo de design. Documento que
// operador assina não pode carregar dado fiscal errado — confirmar com o Caio
// antes de imprimir em produção.
//
// **A inscrição estadual saiu do documento** (decisão do Caio, 2026-09-13) e
// por isso não está aqui: o valor do protótipo era placeholder e o comprovante
// é documento interno, sem valor fiscal — IE não cumpre função nenhuma nele.
// Se um dia voltar, volta com valor conferido.
// ---------------------------------------------------------------------------

export const COMPANY = {
   legalName: 'MyShop Comércio e Serviços LTDA',
   cnpj: '11.156.936/0001-22',
   // Endereço por filial: sem contrato (ver aviso acima).
   branchAddress: null,
};

// Aviso obrigatório em todos os formatos do comprovante (checklist de aceite
// do handoff de design). Não é decoração: é o que separa um documento interno
// de conferência de um documento fiscal.
export const INTERNAL_DOC_NOTICE = 'Documento interno — sem valor fiscal';

export default COMPANY;
